"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SQRT2Dependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var SQRT2Dependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createSQRT2: _factoriesAny.createSQRT2
};
exports.SQRT2Dependencies = SQRT2Dependencies;